import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { LayoutGrid } from "lucide-react";

const KEYS = ["spedizioni", "ricariche_estero", "italiamobile", "giftcard_catalog", "negozio_hardware", "pec", "kit_accessori"];
const STATES = [["", "Regola"], ["on", "S\u00ec"], ["off", "No"]];

export function AgencyServicesDefaults() {
  const [open, setOpen] = useState(false);
  const [vals, setVals] = useState({});
  const [defs, setDefs] = useState([]);
  const show = async () => { const { data } = await api.get("/admin/agency-services"); setVals(data.values); setDefs(data.defs); setOpen(true); };
  const save = async () => {
    try { await api.put("/admin/agency-services", { values: vals }); toast.success("Regola agenzie salvata"); setOpen(false); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
  };
  return <>
    <Button variant="outline" className="gap-2" onClick={show} data-testid="agency-services-defaults-open"><LayoutGrid className="w-4 h-4" /> Servizi agenzie</Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent data-testid="agency-services-defaults-dialog">
      <DialogHeader><DialogTitle>Servizi per tutte le agenzie</DialogTitle><DialogDescription>Regola base: la scheda di ogni agenzia può cambiarla.</DialogDescription></DialogHeader>
      <div className="grid sm:grid-cols-2 gap-2">{defs.map((d) => <label key={d.key} className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-sm"><span>{d.label}</span><Switch checked={!!vals[d.key]} onCheckedChange={(v) => setVals((s) => ({ ...s, [d.key]: v }))} data-testid={`agency-default-${d.key}`} /></label>)}</div>
      <Button className="w-full" onClick={save} data-testid="agency-services-defaults-save">Salva regola</Button>
    </DialogContent></Dialog>
  </>;
}

export function AgencyServicesButton({ agent }) {
  const [open, setOpen] = useState(false);
  const [ov, setOv] = useState({});
  const [defs, setDefs] = useState([]);
  const show = async () => {
    const { data } = await api.get(`/admin/users/${agent.id}/service-overrides`);
    setOv(data.overrides || {}); setDefs((data.defs || []).filter((d) => KEYS.includes(d.key))); setOpen(true);
  };
  const setState = (k, st) => setOv((s) => { const n = { ...s }; if (!st) delete n[k]; else n[k] = st === "on"; return n; });
  const save = async () => {
    try { await api.put(`/admin/users/${agent.id}/service-overrides`, { overrides: ov }); toast.success("Servizi agenzia aggiornati"); setOpen(false); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
  };
  return <>
    <Button size="sm" variant="outline" className="gap-1" onClick={show} data-testid={`agency-services-${agent.id}`}><LayoutGrid className="w-3.5 h-3.5" /> Servizi visibili</Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent data-testid="agency-services-dialog">
      <DialogHeader><DialogTitle>Servizi di {agent.company_name || agent.name}</DialogTitle><DialogDescription>«Regola» segue la regola uguale per tutte le agenzie.</DialogDescription></DialogHeader>
      <div className="space-y-1.5">{defs.map((d) => { const cur = d.key in ov ? (ov[d.key] ? "on" : "off") : ""; return (
        <div key={d.key} className="flex items-center justify-between gap-2 text-sm"><span>{d.label}</span><div className="flex gap-1">{STATES.map(([st, l]) => <Button key={st || "rule"} type="button" size="sm" className="sim-chip h-8" variant={cur === st ? "default" : "outline"} onClick={() => setState(d.key, st)} data-testid={`agency-svc-${d.key}-${st || "rule"}`}>{l}</Button>)}</div></div>); })}</div>
      <Button className="w-full" onClick={save} data-testid="agency-services-save">Salva</Button>
    </DialogContent></Dialog>
  </>;
}
